module.exports = __webpack_public_path__ + "img/futbol.aa0fb547.svg";